var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h61v38H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0066b2",
    d: "M28.071 24.79h-2.975l1.862-11.447h2.981ZM22.585 13.343l-2.841 7.873-.337-1.7-1-5.148a1.275 1.275 0 0 0-1.414-1.031h-4.7l-.055.194a11.1 11.1 0 0 1 3.118 1.308l2.589 9.945h3.105l4.742-11.447ZM46.023 24.79h2.736l-2.386-11.447h-2.4a1.37 1.37 0 0 0-1.376.853L38.152 24.79h3.106l.621-1.7h3.789Zm-3.279-4.049 1.566-4.285.881 4.285ZM38.392 16.095l.425-2.458a8.6 8.6 0 0 0-2.68-.5c-1.479 0-4.991.646-4.991 3.789 0 2.958 4.123 2.994 4.123 4.547s-3.7 1.276-4.918.3l-.443 2.569a8.35 8.35 0 0 0 3.364.647c2.033 0 5.1-1.053 5.1-3.919 0-2.976-4.16-3.254-4.16-4.548s2.905-1.129 4.18-.427"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a533",
    d: "m19.408 19.522-1-5.148a1.275 1.275 0 0 0-1.414-1.031h-4.7l-.055.194a11.55 11.55 0 0 1 4.423 2.22 8.9 8.9 0 0 1 2.746 3.765"
  })));
};
export { SvgVisa as ReactComponent };
export default "/_next/static/images/visa.svg";